export default __webpack_public_path__ + "static/media/partner23.636e6017.webp";